import * as React from "react";
import {
  SimpleForm,
  NumberInput,
  required,
  maxValue,
  TextInput,
} from "react-admin";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Alert,
  FormControlLabel,
  Checkbox,
  DialogActions,
} from "@mui/material";
import {
  COUNT_AIRBAG_MAX,
  COUNT_BINS_MAX,
  integerOnly,
} from "../../validators";

const FORM_ID = "removal-request-form";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: any) => void;
  certified: boolean;
  setCertified: (v: boolean) => void;
  clientId: string;
}

export const RemovalRequestDialog: React.FC<Props> = ({
  open,
  onClose,
  onSubmit,
  certified,
  setCertified,
  clientId,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Demande d'enlèvement</DialogTitle>
    <DialogContent>
      <Alert severity="info" sx={{ mb: 2 }}>
        Après le scan par le prestataire, votre stock sera mis à jour
        automatiquement.
      </Alert>
      <SimpleForm id={FORM_ID} onSubmit={onSubmit} toolbar={false}>
        <NumberInput
          source="fullBinsCount"
          label="Caisses pleines"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre entier"),
          ]}
          fullWidth
        />
        <NumberInput
          source="emptyBinsCount"
          label="Caisses vides"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre entier"),
          ]}
          fullWidth
        />
        <NumberInput
          source="airbagsCount"
          label="Nb d'airbag en vrac"
          defaultValue={0}
          validate={[
            required("Le nombre d'airbag en vrac est requis"),
            maxValue(COUNT_AIRBAG_MAX, `Maximum ${COUNT_AIRBAG_MAX}`),
            integerOnly("Doit être un nombre entier"),
          ]}
          fullWidth
        />
        <TextInput
          source="clientId"
          defaultValue={clientId}
          sx={{ display: "none" }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={certified}
              onChange={(e) => setCertified(e.target.checked)}
            />
          }
          label="Je certifie que les données insérées sont correctes."
        />
      </SimpleForm>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose} color="warning" variant="outlined">
        Annuler
      </Button>
      <Button
        type="submit"
        form={FORM_ID}
        color="primary"
        variant="outlined"
        disabled={!certified}
      >
        Envoyer
      </Button>
    </DialogActions>
  </Dialog>
);
